module.exports = __webpack_public_path__ + "static/img/backupimg.d0289dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/backupimg.png
// module id = pC5Z
// module chunks = 10